import AssetAdapter from './asset.js';
const deconstructPairId = (pairId) => {
    const deconstructedPairId = pairId.match(/^(?<from>.+)_(?<to>.+)$/u)?.groups;
    return deconstructedPairId || { from: '', to: '' };
};
class PairAdapter {
    #assetAdapter;
    constructor(params) {
        this.#assetAdapter = new AssetAdapter(params);
    }
    toWalletPairId(exchangePairId) {
        const { from, to } = deconstructPairId(exchangePairId);
        const adaptedFrom = this.#assetAdapter.toWalletId(from);
        const adaptedTo = this.#assetAdapter.toWalletId(to);
        return `${adaptedFrom}_${adaptedTo}`;
    }
    toExchangePairId(walletPairId) {
        const { from, to } = deconstructPairId(walletPairId);
        const adaptedFrom = this.#assetAdapter.toExchangeId(from);
        const adaptedTo = this.#assetAdapter.toExchangeId(to);
        return `${adaptedFrom}_${adaptedTo}`;
    }
}
export default PairAdapter;
